'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reactImmutableProptypes2.default.contains({
  count: _react.PropTypes.number,
  limit: _react.PropTypes.number,
  page: _react.PropTypes.number,
  pages: _react.PropTypes.number
});


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/paginationShape.js
// module id = 71
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16